import React from "react";
const RicosDevToolsLazy = React.lazy(
  () => import(
    /* webpackChunkName: "ricos-dev-tools" */
    "./RicosDevTools.js"
  )
);
export {
  RicosDevToolsLazy
};
//# sourceMappingURL=RicosDevToolsLazy.js.map
